// extracted by mini-css-extract-plugin
var _1 = "SignUpForm-module__button___M01Ve";
var _2 = "SignUpForm-module__container___ocpvJ";
var _3 = "SignUpForm-module__content___U8HTr";
var _4 = "SignUpForm-module__create____xRcw";
var _5 = "SignUpForm-module__form___wdXD3";
var _6 = "SignUpForm-module__header___YBkBn";
var _7 = "SignUpForm-module__or___Kpug3";
var _8 = "SignUpForm-module__tagalongHeading___KizqZ";
export { _1 as "button", _2 as "container", _3 as "content", _4 as "create", _5 as "form", _6 as "header", _7 as "or", _8 as "tagalongHeading" }
